import { adminDashboardConstants } from '../_constants';
import { adminDashboardServices } from '../_services';

export const adminDashboard = {
    getAdminDashboardCards,
    getAdminDashboardCharts
};

function getAdminDashboardCards() {
    return dispatch => {
        dispatch(request());
        adminDashboardServices.getAdminDashboardCards()
            .then(
                adminDashboardCards => dispatch(success(adminDashboardCards)),
                error => dispatch(failure(error.toString()))
            );
    };

    function request() { return { type: adminDashboardConstants.GET_ADMIN_DASHBOARD_CARDS_REQUEST } }
    function success(adminDashboardCards) { return { type: adminDashboardConstants.GET_ADMIN_DASHBOARD_CARDS_SUCCESS, adminDashboardCards } }
    function failure(error) { return { type: adminDashboardConstants.GET_ADMIN_DASHBOARD_CARDS_FAILURE, error } }
}

function getAdminDashboardCharts() {
    return dispatch => {
        dispatch(request());
        adminDashboardServices.getAdminDashboardCharts()
            .then(
                adminDashboardCharts => dispatch(success(adminDashboardCharts)),
                error => dispatch(failure(error.toString()))
            );
    };

    function request() { return { type: adminDashboardConstants.GET_ADMIN_DASHBOARD_CHARTS_REQUEST } }
    function success(adminDashboardCharts) { return { type: adminDashboardConstants.GET_ADMIN_DASHBOARD_CHARTS_SUCCESS, adminDashboardCharts } }
    function failure(error) { return { type: adminDashboardConstants.GET_ADMIN_DASHBOARD_CHARTS_FAILURE, error } }
}